import React from 'react';
import StarRating, { StarText } from './TestimonialStars';
import { SOURCE_STYLES } from './testimonialUtils';

export const PullQuotePreview = ({ testimonial }) => {
  const routeLine = [testimonial.route, testimonial.travel_month].filter(Boolean).join(' · ');
  return (
    <div
      style={{
        background: 'white',
        borderLeft: '4px solid #E8651A',
        borderRadius: '0 12px 12px 0',
        padding: '24px 32px',
        maxWidth: '700px',
      }}
    >
      <span
        className="font-display block"
        style={{ fontSize: '64px', color: '#E8651A', opacity: 0.3, lineHeight: 0, marginBottom: '-16px' }}
        aria-hidden
      >
        &ldquo;
      </span>
      <p className="font-display italic text-[#1B2D5E]" style={{ fontSize: '20px', lineHeight: 1.6 }}>
        {testimonial.review_text || 'Review text will appear here…'}
      </p>
      <p className="font-body font-semibold text-[#333] mt-3" style={{ fontSize: '13px' }}>
        — {testimonial.customer_name || 'Customer Name'}
      </p>
      {routeLine && (
        <p className="font-body text-[#888]" style={{ fontSize: '12px' }}>
          {routeLine}
        </p>
      )}
      <div className="mt-1">
        <StarText rating={testimonial.rating || 5} />
      </div>
    </div>
  );
};

export const ReviewCardPreview = ({ testimonial }) => {
  const sourceClass = SOURCE_STYLES[testimonial.source] || SOURCE_STYLES.Other;
  return (
    <div
      style={{
        background: 'white',
        border: '1px solid #EBEBEB',
        borderRadius: '14px',
        padding: '24px',
      }}
    >
      <div className="flex items-center justify-between gap-3 mb-4">
        <StarRating value={testimonial.rating || 5} readonly size={16} />
        {testimonial.source && (
          <span className={`text-[11px] font-medium px-2.5 py-0.5 rounded-full ${sourceClass}`}>
            {testimonial.source}
          </span>
        )}
      </div>
      <p className="font-body text-[#555] mb-4" style={{ fontSize: '14px', lineHeight: 1.7 }}>
        {testimonial.review_text || 'Review text will appear here…'}
      </p>
      <p className="font-body font-semibold text-[#1B2D5E]" style={{ fontSize: '14px' }}>
        {testimonial.customer_name || 'Customer Name'}
      </p>
      {testimonial.route && (
        <p className="font-body text-[#E8651A]" style={{ fontSize: '12px' }}>
          {testimonial.route}
        </p>
      )}
      {testimonial.travel_month && (
        <p className="font-body text-[#888]" style={{ fontSize: '12px' }}>
          {testimonial.travel_month}
        </p>
      )}
    </div>
  );
};

export const WebsitePreview = ({ testimonial }) => (
  <div>
    <p
      className="font-body uppercase mb-3"
      style={{ fontSize: '11px', color: '#888', letterSpacing: '2px' }}
    >
      Preview on website
    </p>
    {testimonial.is_featured ? (
      <PullQuotePreview testimonial={testimonial} />
    ) : (
      <ReviewCardPreview testimonial={testimonial} />
    )}
  </div>
);

export default WebsitePreview;
